import ExternalUrlFormStep from './StepContent/ExternalUrlFormStep'
import ExternalDataRetrievalStep from './StepContent/ExternalDataRetrievalStep'
import ExternalAssetsUploadStep from './StepContent/ExternalAssetsUploadStep'
import ExternalProposalCreateStep from './StepContent/ExternalProposalCreateStep'

/**
 * Single source of truth for step titles and components.
 * Step 0: 輸入賣場 (form), 1: 取得資料 (fetch), 2: 上傳資料 (upload), 3: 建立提案 (create).
 */
export const STEP_CONFIG = [
  { title: '輸入賣場', component: ExternalUrlFormStep },
  { title: '取得資料', component: ExternalDataRetrievalStep },
  { title: '上傳資料', component: ExternalAssetsUploadStep },
  { title: '建立提案', component: ExternalProposalCreateStep }
]

export const STEP_TITLES = STEP_CONFIG.map((s) => s.title)
